function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.17 12.5H15.83c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h28.33c.46 0 .83.37.83.83s-.36.83-.82.83zm0 13.33H15.83c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h28.33c.46 0 .83.37.83.83s-.36.83-.82.83zm0 13.34H15.83c-.46 0-.83-.37-.83-.83s.37-.83.83-.83h28.33c.46 0 .83.37.83.83s-.36.83-.82.83zm-35-10C6.87 29.17 5 27.3 5 25s1.87-4.17 4.17-4.17 4.17 1.87 4.17 4.17-1.88 4.17-4.17 4.17zm0-6.67a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm0 20C6.87 42.5 5 40.63 5 38.33s1.87-4.17 4.17-4.17 4.17 1.87 4.17 4.17c-.01 2.3-1.88 4.17-4.17 4.17zm0-6.67a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm0-20c-2.3 0-4.17-1.87-4.17-4.17S6.87 7.5 9.17 7.5s4.17 1.87 4.17 4.17-1.88 4.16-4.17 4.16zm0-6.66a2.5 2.5 0 000 5 2.5 2.5 0 000-5z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/list.80d7238f.svg";
export { SvgComponent as ReactComponent };